<template>
  <div class="card card-profile">
    <img src="/img/theme/bg-card.png" alt="Image placeholder" class="card-img-top">

    <div class="row justify-content-center">
      <div class="col-lg-3 order-lg-2">
        <div class="card-profile-image">
          <a href="#">
            <img src="/img/theme/usuario_default.png" class="bg-gray rounded-circle">
          </a>
        </div>
      </div>
    </div>

    <div class="card-header text-center border-0 py-4"></div>

    <div class="card-body">
      <div class="text-center">
        <badge rounded size="lg" type="default" v-show="(dataUserActual.adminUser==true)">
          Administrador
        </badge>
      </div>
      <div class="row">
          <div class="col">
              <div class="card-profile-stats d-flex justify-content-around py-0">
                  <div class="px-0">
                    <span class="description">ID</span>
                    <span class="heading">{{ dataUserActual.customerUserId }}</span>
                  </div>
              </div>
          </div>
          <div class="col">
              <div class="card-profile-stats d-flex justify-content-around py-0">
                  <div class="px-0">
                    <span class="description">Nombre cuenta</span>
                    <span class="heading">{{ dataUserActual.shortName }}</span>
                  </div>
              </div>
          </div>
          <div class="col">
              <div class="card-profile-stats d-flex justify-content-around py-0">
                  <div class="px-0">
                    <span class="description">Créditos propios</span>
                    <span class="heading">{{ numberWithCommas(dataUserActual.remainingSms) }}</span>
                  </div>
              </div>
          </div>
      </div>
      <hr>
      <div class="text-center card-text">

        <ul class="list-unstyled my-4">
          <li>
            <div class="d-flex align-items-center mb-2">
              <div>
                <div class="icon icon-xs icon-shape bg-gradient-default text-white rounded-circle">
                  <i class="fas fa-money-check-alt"></i>
                </div>
              </div>
              <div>
                <span class="pl-2 text-sm">
                  Tipo de cuenta

                  <span class="font-weight-300 text-gray">
                    {{ tipoCuenta() }}
                  </span>
                </span>
              </div>
            </div>
          </li>

          <li>
            <div class="d-flex align-items-center mb-2">
              <div>
                <div class="icon icon-xs icon-shape bg-gradient-default text-white rounded-circle">
                  <i class="fas fa-calendar-day"></i>
                </div>
              </div>
              <div>
                <span class="pl-2 text-sm">
                  Fecha de creación

                  <span class="font-weight-300 text-gray">
                    {{ fechaFormato(dataUserActual.customer.created) }}
                  </span>
                </span>
              </div>
            </div>
          </li>

          <li>
            <div class="d-flex align-items-center mb-2">
              <div>
                <div class="icon icon-xs icon-shape bg-gradient-default text-white rounded-circle">
                  <i class="fas fa-globe"></i>
                </div>
              </div>
              <div>
                <span class="pl-2 text-sm">
                  País

                  <span class="font-weight-300 text-gray">
                    {{ dataUserActual.customer.country.name }}
                  </span>
                </span>
              </div>
            </div>
          </li>

          <li>
            <div class="d-flex align-items-center mb-2">
              <div>
                <div class="icon icon-xs icon-shape bg-gradient-default text-white rounded-circle">
                  <i class="fas fa-language"></i>
                </div>
              </div>
              <div>
                <span class="pl-2 text-sm">
                  Idioma

                  <span class="font-weight-300 text-gray">
                    {{ dataUserActual.customer.language.name }}
                  </span>
                </span>
              </div>
            </div>
          </li>

          <li>
            <div class="d-flex align-items-center mb-2">
              <div>
                <div class="icon icon-xs icon-shape bg-gradient-default text-white rounded-circle">
                  <i class="fas fa-clock"></i>
                </div>
              </div>
              <div>
                <span class="pl-2 text-sm">
                  Zona Horaria

                  <span class="font-weight-300 text-gray">
                    {{ dataUserActual.customer.gmtTimezoneInterval }}
                  </span>
                </span>
              </div>
            </div>
          </li>
        </ul>

      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import { BasePagination, Modal, Dialog } from '@/components';

import moment from 'moment';

import AES256 from 'aes-everywhere';
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Config from '@/config/config.js'
import { getUser, setUser, encryptAES, horaAhora } from '@/util/util.js';

Vue.use(VueAxios, axios)
Vue.use(Dialog)

export default {
  data() {
      return {
        dataUser: {},
        dataUserActual:  getUser(),
        fileSingle: [],
      };
    },
    methods: {


      tipoCuenta(){
        var resp="NA";


        if(this.dataUserActual.customer.postpaid==true && this.dataUserActual.customer.monthlyLimit==true){
          resp = "PostPago"
        }

        if(this.dataUserActual.customer.postpaid==false && this.dataUserActual.customer.monthlyLimit==true){
          resp = "PrePago"
        }

        if(this.dataUserActual.customer.postpaid==true && this.dataUserActual.customer.monthlyLimit==false){
          resp = "PostPago"
        }

        return resp;
      },
     obtenerInfoCuenta() {

      let self = this;
      let user = getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.costumer_user_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {

            if (response.data.response == "200") {

              self.dataUser = response.data.data;

              self.dataUser.forEach(function(element) {
                if(element.customerUserId === user.customerUserId) {

                    self.dataUserActual = element;
                    console.log(element)
                }
              })

            } else {
              console.log("No se encontró usuario");
              swal({
                title: 'No se encontró usuario',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'warning',
              })
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontró usuario",error);
            swal({
                title: 'No se encontró usuario',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'warning',
            })
            self.$loading.hide();
        });

      },
      fechaFormato(unixTimestamp) {
        return moment(unixTimestamp).format('YYYY-MM-DD');
      },
      numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    mounted() {
     this.obtenerInfoCuenta();
    }
};
</script>
<style></style>
